import { useQuery } from "@apollo/client/react";
import { gql } from "@/__generated__";

export const HAS_SURVEY_SCHEMA_FOR_APPEAL = gql(`
  query HasSurveySchemaForAppeal($appealId: ID!) {
    hasSurveySchemaForAppeal(appealId: $appealId)
  }
`);

interface UseHasSurveySchemaResult {
  hasSurveySchema: boolean;
  loading: boolean;
}

export const useHasSurveySchema = (
  appealId: string | undefined,
): UseHasSurveySchemaResult => {
  const { data, loading } = useQuery(HAS_SURVEY_SCHEMA_FOR_APPEAL, {
    variables: { appealId: appealId ?? "" },
    fetchPolicy: "cache-and-network",
    skip: !appealId,
  });

  return {
    hasSurveySchema: data?.hasSurveySchemaForAppeal ?? false,
    loading,
  };
};
